const staticRoutes = [
  {
    route: 'general-info',
    key: 'SP_GENERAL_INFO',
  },
  {
    route: 'contacts',
    key: 'SP_CONTACTS',
  },
  {
    route: 'editorial-principles',
    key: 'SP_EDITORIAL_PRINCIPLES',
  },
  {
    route: 'rules',
    key: 'SP_RULES',
  },
  {
    route: 'policy',
    key: 'SP_POLICY',
  },
  {
    route: 'advertisers',
    key: 'SP_ADVERTISERS',
  },
];

export { staticRoutes };
